import { axiosGet, axiosPut, axiosPost, handleOnError } from '../utils/api';

class RulesService {
    // country codes that have their own override (excludes 'default')
    async getCustomizedCountries() {
        try {
            let response = await axiosGet('rules/countries');
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // resolved rules for a country (or 'default') + isCustomized flag
    async getCountryRules(country) {
        try {
            let response = await axiosGet(`rules/${country}`);
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    async updateCountryRules(country, rules) {
        try {
            let response = await axiosPut(`rules/${country}`, { rules });
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    async resetCountryRules(country) {
        try {
            let response = await axiosPost(`rules/${country}/reset`, {});
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // paginated audit history for a country (most recent first)
    async getCountryAudit(country, { page = 1, limit = 10 } = {}) {
        try {
            let response = await axiosGet(`rules/${country}/audit`, { page, limit });
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // union of all rule column names (for column-picker master lists)
    async getColumns() {
        try {
            let response = await axiosGet('rules/columns');
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }

    // a stored rules snapshot by hash (e.g. the rules used for an upload)
    async getSnapshot(hash) {
        try {
            let response = await axiosGet(`rules/snapshot/${hash}`);
            return response.data;
        } catch (error) {
            return await handleOnError(error);
        }
    }
}

export default new RulesService();
